// This file is auto-generated by @hey-api/openapi-ts

export const $Address = {
  type: "object",
  description: "Serializer for the comprehensive Address model",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    street_address: {
      type: "string",
      description: "Street address, apartment, suite, etc.",
      maxLength: 255,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    state_province: {
      type: "string",
      description: "State, province, or region",
      maxLength: 100,
    },
    postal_code: {
      type: "string",
      description: "ZIP code, postal code, etc.",
      maxLength: 20,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    latitude: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,3}(?:\\.\\d{0,6})?$",
      nullable: true,
      description: "Latitude for geocoding and distance calculations",
    },
    longitude: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,3}(?:\\.\\d{0,6})?$",
      nullable: true,
      description: "Longitude for geocoding and distance calculations",
    },
    is_remote_preferred: {
      type: "boolean",
      description: "User prefers remote work over this location",
    },
    is_verified: {
      type: "boolean",
      description: "Address has been verified through geocoding",
    },
    formatted_address: {
      type: "string",
      readOnly: true,
      description: "Full formatted address string for display",
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: ["created", "formatted_address", "id", "updated"],
} as const;

export const $AddressSearch = {
  type: "object",
  description: "Serializer for address data in search results",
  properties: {
    city: {
      type: "string",
      nullable: true,
    },
    state: {
      type: "string",
      nullable: true,
    },
    country: {
      type: "string",
      nullable: true,
    },
    formatted_address: {
      type: "string",
      nullable: true,
    },
  },
  required: ["city", "country", "formatted_address", "state"],
} as const;

export const $Application = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    experiences: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Experience",
      },
      readOnly: true,
    },
    educations: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Education",
      },
      readOnly: true,
    },
    skills: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ApplicationSkill",
      },
      readOnly: true,
    },
    projects: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Project",
      },
      readOnly: true,
    },
    awards: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Award",
      },
      readOnly: true,
    },
    certifications: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Certification",
      },
      readOnly: true,
    },
    publications: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Publication",
      },
      readOnly: true,
    },
    profiles: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Profile",
      },
      readOnly: true,
    },
    linkedin: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    github: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    portfolio: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    description: {
      type: "string",
    },
    summary: {
      type: "string",
      description: "Professional summary or objective",
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    user: {
      type: "integer",
    },
  },
  required: [
    "awards",
    "certifications",
    "created",
    "educations",
    "experiences",
    "id",
    "profiles",
    "projects",
    "publications",
    "skills",
    "updated",
    "user",
  ],
} as const;

export const $ApplicationID = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
  },
  required: ["id"],
} as const;

export const $ApplicationSearch = {
  type: "object",
  description: "Serializer for application data in search results",
  properties: {
    description: {
      type: "string",
      nullable: true,
    },
    summary: {
      type: "string",
      nullable: true,
    },
    linkedin: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    github: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    portfolio: {
      type: "string",
      format: "uri",
      nullable: true,
    },
  },
  required: ["description", "github", "linkedin", "portfolio", "summary"],
} as const;

export const $ApplicationSkill = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    score: {
      type: "integer",
      maximum: 2147483647,
      minimum: -2147483648,
    },
    application: {
      type: "integer",
    },
    matching_skill: {
      allOf: [
        {
          $ref: "#/components/schemas/MatchingSkill",
        },
      ],
      readOnly: true,
    },
    matching_skill_id: {
      type: "integer",
      writeOnly: true,
      nullable: true,
    },
  },
  required: ["application", "id", "matching_skill", "name", "score"],
} as const;

export const $Award = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    issuer: {
      type: "string",
      maxLength: 255,
    },
    date_received: {
      type: "string",
      format: "date",
      nullable: true,
    },
    application: {
      type: "integer",
    },
  },
  required: ["application", "id", "name"],
} as const;

export const $BlankEnum = {
  enum: [""],
} as const;

export const $BusinessRoleEnum = {
  enum: [
    "owner",
    "ceo",
    "gm",
    "marketing",
    "operations",
    "hr",
    "finance",
    "sales",
    "it",
    "customer_service",
    "consultant",
    "recruiter",
    "other",
  ],
  type: "string",
  description: `* \`owner\` - Owner/Founder
* \`ceo\` - CEO/President
* \`gm\` - General Manager
* \`marketing\` - Marketing Manager
* \`operations\` - Operations Manager
* \`hr\` - HR Manager
* \`finance\` - Finance Manager
* \`sales\` - Sales Manager
* \`it\` - IT Manager
* \`customer_service\` - Customer Service Manager
* \`consultant\` - Consultant
* \`recruiter\` - Recruiter
* \`other\` - Other`,
} as const;

export const $CandidatePreferences = {
  type: "object",
  description: "Serializer for candidate job preferences",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    user: {
      type: "integer",
      readOnly: true,
      description: "The candidate these preferences belong to",
    },
    role: {
      type: "string",
      description: "Preferred job role or position",
      maxLength: 255,
    },
    locations: {
      description: "List of preferred locations",
    },
    opportunity_type: {
      allOf: [
        {
          $ref: "#/components/schemas/OpportunityTypeEnum",
        },
      ],
      description: `Preferred opportunity type

* \`All\` - All
* \`Full Time\` - Full Time
* \`Part Time\` - Part Time
* \`Volunteer\` - Volunteer
* \`AI gig\` - AI gig`,
    },
    preferred_salary: {
      description: `Preferred salary range

* \`10K - 100K\` - 10K - 100K
* \`100K - 200K\` - 100K - 200K
* \`200K - 300K\` - 200K - 300K
* \`More than 300K\` - More than 300K`,
      oneOf: [
        {
          $ref: "#/components/schemas/PreferredSalaryEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    job_types: {
      type: "array",
      items: {
        $ref: "#/components/schemas/JobTypesEnum",
      },
    },
    company_sizes: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CompanySizesEnum",
      },
    },
    investment_stages: {
      type: "array",
      items: {
        $ref: "#/components/schemas/InvestmentStagesEnum",
      },
    },
    open_to_remote: {
      type: "boolean",
      description: "Whether candidate is open to remote work",
    },
    requires_visa_sponsorship: {
      type: "boolean",
      description: "Whether candidate requires visa sponsorship",
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: ["created", "id", "updated", "user"],
} as const;

export const $CandidatePublicProfile = {
  type: "object",
  description:
    "Serializer for public candidate profile data accessible by recruiters",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    profile_picture: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    address_details: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      readOnly: true,
    },
    role: {
      allOf: [
        {
          $ref: "#/components/schemas/RoleEnum",
        },
      ],
      readOnly: true,
    },
    is_volunteer: {
      type: "boolean",
      description: "Check if this candidate is available as a volunteer",
    },
    is_looking_for_job: {
      type: "boolean",
      description: "Check if this candidate is actively looking for a job",
    },
    applicationids: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ApplicationID",
      },
      readOnly: true,
    },
  },
  required: ["address_details", "applicationids", "id", "name", "role"],
} as const;

export const $CandidateSearch = {
  type: "object",
  description: "Serializer for candidate search results",
  properties: {
    id: {
      type: "integer",
    },
    name: {
      type: "string",
    },
    email: {
      type: "string",
      format: "email",
    },
    role: {
      type: "string",
    },
    is_looking_for_job: {
      type: "boolean",
    },
    address: {
      allOf: [
        {
          $ref: "#/components/schemas/AddressSearch",
        },
      ],
      nullable: true,
    },
    application: {
      allOf: [
        {
          $ref: "#/components/schemas/ApplicationSearch",
        },
      ],
      nullable: true,
    },
    skills: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SkillSearch",
      },
    },
    experiences: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ExperienceSearch",
      },
    },
    education: {
      type: "array",
      items: {
        $ref: "#/components/schemas/EducationSearch",
      },
    },
    profile_picture: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    search_rank: {
      type: "number",
      format: "double",
    },
    match_score: {
      type: "number",
      format: "double",
    },
    total_score: {
      type: "number",
      format: "double",
    },
  },
  required: [
    "address",
    "application",
    "education",
    "email",
    "experiences",
    "id",
    "is_looking_for_job",
    "match_score",
    "name",
    "profile_picture",
    "role",
    "search_rank",
    "skills",
    "total_score",
  ],
} as const;

export const $CategoryEnum = {
  enum: ["feature", "fix", "chore"],
  type: "string",
  description: `* \`feature\` - Feature
* \`fix\` - Fix
* \`chore\` - Chore`,
} as const;

export const $Certification = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    issuer: {
      type: "string",
      maxLength: 255,
    },
    issue_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    expiry_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    credential_id: {
      type: "string",
      maxLength: 255,
    },
    application: {
      type: "integer",
    },
  },
  required: ["application", "id", "name"],
} as const;

export const $ChangeLogEntry = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
      description: "Brief explanation of the change.",
    },
    category: {
      $ref: "#/components/schemas/CategoryEnum",
    },
    pr_number: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
    },
    pr_url: {
      type: "string",
      format: "uri",
      readOnly: true,
    },
    task_refs: {
      type: "string",
      description: "Comma-separated issue numbers, e.g. '#174, #175'.",
      maxLength: 255,
    },
    occurred_at: {
      type: "string",
      format: "date-time",
      description: "When the PR merged.",
    },
  },
  required: ["id", "occurred_at", "pr_number", "pr_url", "title"],
} as const;

export const $ChapterLeaderboard = {
  type: "object",
  properties: {
    rank: {
      type: "integer",
    },
    id: {
      type: "integer",
    },
    name: {
      type: "string",
    },
    slug: {
      type: "string",
    },
    tier: {
      type: "string",
    },
    tier_display: {
      type: "string",
    },
    score: {
      type: "integer",
    },
  },
  required: ["id", "name", "rank", "score", "slug", "tier", "tier_display"],
} as const;

export const $Company = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    smallbiz_profile: {
      allOf: [
        {
          $ref: "#/components/schemas/SmallBusinessProfile",
        },
      ],
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    address: {
      type: "string",
    },
    description: {
      type: "string",
    },
    website: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    logo: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    contact_email: {
      oneOf: [
        {
          type: "string",
          format: "email",
          maxLength: 254,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    phone_number: {
      type: "string",
      maxLength: 20,
    },
    is_small_business: {
      type: "boolean",
      description:
        "Check if this is a small business (listed on volunteer portal)",
    },
    is_nonprofit: {
      type: "boolean",
      description: "Check if this is a nonprofit organization",
    },
    industry: {
      oneOf: [
        {
          $ref: "#/components/schemas/IndustryEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    employee_count: {
      oneOf: [
        {
          $ref: "#/components/schemas/EmployeeCountEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    culture: {
      type: "string",
      description: "Describe the company culture, values, and work environment",
    },
    hiring_goals: {
      type: "string",
      description: "Describe the company's hiring goals and objectives",
    },
    roles_hiring_for: {
      type: "string",
      description: "Types of roles the company is currently hiring for",
    },
    positions_to_hire: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
      nullable: true,
      description: "Number of positions the company plans to hire",
    },
  },
  required: ["address", "id", "name", "smallbiz_profile"],
} as const;

export const $CompanySizesEnum = {
  enum: [
    "1-10 employees",
    "11-50 employees",
    "51-200 employees",
    "201-500 employees",
    "501-1000 employees",
    "1001-5000 employees",
    "5000+ employees",
  ],
  type: "string",
  description: `* \`1-10 employees\` - 1-10 employees
* \`11-50 employees\` - 11-50 employees
* \`51-200 employees\` - 51-200 employees
* \`201-500 employees\` - 201-500 employees
* \`501-1000 employees\` - 501-1000 employees
* \`1001-5000 employees\` - 1001-5000 employees
* \`5000+ employees\` - 5000+ employees`,
} as const;

export const $DeveloperLeaderboard = {
  type: "object",
  properties: {
    rank: {
      type: "integer",
    },
    id: {
      type: "integer",
    },
    name: {
      type: "string",
    },
    score: {
      type: "integer",
    },
  },
  required: ["id", "name", "rank", "score"],
} as const;

export const $DigitalProficiencyEnum = {
  enum: [1, 2, 3, 4, 5],
  type: "integer",
  description: `* \`1\` - 1
* \`2\` - 2
* \`3\` - 3
* \`4\` - 4
* \`5\` - 5`,
} as const;

export const $Education = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    institution: {
      type: "string",
      maxLength: 255,
    },
    degree: {
      type: "string",
      maxLength: 255,
    },
    field_of_study: {
      type: "string",
      maxLength: 255,
    },
    gpa: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,1}(?:\\.\\d{0,2})?$",
      nullable: true,
      description: "Grade Point Average (0.00-4.00)",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    application: {
      type: "integer",
    },
  },
  required: ["application", "id", "institution", "start_date"],
} as const;

export const $EducationSearch = {
  type: "object",
  description: "Serializer for education in search results",
  properties: {
    institution: {
      type: "string",
    },
    degree: {
      type: "string",
    },
    field_of_study: {
      type: "string",
    },
  },
  required: ["degree", "field_of_study", "institution"],
} as const;

export const $EmployeeCountEnum = {
  enum: ["sole", "2_5", "6_15", "16_30", "31_50", "50_plus"],
  type: "string",
  description: `* \`sole\` - Just myself (Sole Proprietor)
* \`2_5\` - 2-5
* \`6_15\` - 6-15
* \`16_30\` - 16-30
* \`31_50\` - 31-50
* \`50_plus\` - More than 50`,
} as const;

export const $Event = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 200,
    },
    description: {
      type: "string",
    },
    event_type: {
      $ref: "#/components/schemas/EventTypeEnum",
    },
    start_date: {
      type: "string",
      format: "date-time",
    },
    end_date: {
      type: "string",
      format: "date-time",
    },
    location: {
      type: "string",
      maxLength: 200,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    is_online: {
      type: "boolean",
    },
    online_url: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    max_participants: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
      nullable: true,
    },
    current_participants: {
      type: "integer",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
      readOnly: true,
    },
    tag_ids: {
      type: "array",
      items: {
        type: "integer",
        writeOnly: true,
      },
      writeOnly: true,
    },
    organizer_name: {
      type: "string",
      maxLength: 200,
    },
    organizer_email: {
      type: "string",
      format: "email",
      maxLength: 254,
    },
    organizer_phone: {
      type: "string",
      maxLength: 20,
    },
    registration_required: {
      type: "boolean",
    },
    registration_deadline: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
    cost: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
      nullable: true,
    },
    currency: {
      type: "string",
      maxLength: 3,
    },
    is_full: {
      type: "boolean",
      readOnly: true,
    },
    registration_open: {
      type: "boolean",
      readOnly: true,
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: [
    "city",
    "country",
    "created",
    "current_participants",
    "description",
    "end_date",
    "id",
    "is_full",
    "location",
    "modified",
    "organizer_email",
    "organizer_name",
    "registration_open",
    "start_date",
    "tags",
    "title",
  ],
} as const;

export const $EventList = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 200,
    },
    event_type: {
      $ref: "#/components/schemas/EventTypeEnum",
    },
    start_date: {
      type: "string",
      format: "date-time",
    },
    end_date: {
      type: "string",
      format: "date-time",
    },
    location: {
      type: "string",
      maxLength: 200,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    is_online: {
      type: "boolean",
    },
    is_active: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
      readOnly: true,
    },
    is_full: {
      type: "boolean",
      readOnly: true,
    },
    registration_open: {
      type: "boolean",
      readOnly: true,
    },
  },
  required: [
    "city",
    "country",
    "end_date",
    "id",
    "is_full",
    "location",
    "registration_open",
    "start_date",
    "tags",
    "title",
  ],
} as const;

export const $EventTypeEnum = {
  enum: [
    "workshop",
    "seminar",
    "conference",
    "networking",
    "training",
    "webinar",
    "other",
  ],
  type: "string",
  description: `* \`workshop\` - Workshop
* \`seminar\` - Seminar
* \`conference\` - Conference
* \`networking\` - Networking
* \`training\` - Training
* \`webinar\` - Webinar
* \`other\` - Other`,
} as const;

export const $Experience = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    company: {
      type: "string",
      maxLength: 255,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    city: {
      type: "string",
      maxLength: 255,
    },
    state: {
      type: "string",
      maxLength: 255,
    },
    country: {
      type: "string",
      maxLength: 255,
    },
    is_remote: {
      type: "boolean",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    responsibilities: {
      type: "string",
    },
    application: {
      type: "integer",
    },
  },
  required: [
    "application",
    "company",
    "id",
    "responsibilities",
    "start_date",
    "title",
  ],
} as const;

export const $ExperienceSearch = {
  type: "object",
  description: "Serializer for experiences in search results",
  properties: {
    company: {
      type: "string",
    },
    title: {
      type: "string",
    },
    responsibilities: {
      type: "string",
    },
  },
  required: ["company", "responsibilities", "title"],
} as const;

export const $FreeAgent = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      readOnly: true,
    },
    is_free_agent: {
      type: "boolean",
      description: "Whether the developer is open to team invites.",
    },
    headline: {
      type: "string",
      description: "Short pitch shown in the hub.",
      maxLength: 255,
    },
  },
  required: ["id", "name"],
} as const;

export const $GoogleAuth = {
  type: "object",
  properties: {
    token: {
      type: "string",
    },
  },
  required: ["token"],
} as const;

export const $IndustryEnum = {
  enum: [
    "retail",
    "food_beverage",
    "professional_services",
    "healthcare",
    "trades",
    "ecommerce",
    "creative",
    "nonprofit",
    "other",
  ],
  type: "string",
  description: `* \`retail\` - Retail
* \`food_beverage\` - Food & Beverage
* \`professional_services\` - Professional Services
* \`healthcare\` - Healthcare/Wellness
* \`trades\` - Trades/Services
* \`ecommerce\` - E-commerce/Online Business
* \`creative\` - Creative/Design
* \`nonprofit\` - Non-profit
* \`other\` - Other`,
} as const;

export const $InvestmentStagesEnum = {
  enum: ["NA", "Seed", "Series A", "Series B", "Growth", "IPO", "Acquired"],
  type: "string",
  description: `* \`NA\` - NA
* \`Seed\` - Seed
* \`Series A\` - Series A
* \`Series B\` - Series B
* \`Growth\` - Growth
* \`IPO\` - IPO
* \`Acquired\` - Acquired`,
} as const;

export const $JobProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    keywords: {
      type: "string",
    },
    salary_min: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
    },
    salary_max: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
    },
    city: {
      type: "string",
      maxLength: 255,
    },
    state: {
      type: "string",
      maxLength: 255,
    },
    country: {
      type: "string",
      maxLength: 255,
    },
    latitude: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,3}(?:\\.\\d{0,6})?$",
      nullable: true,
    },
    longitude: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,3}(?:\\.\\d{0,6})?$",
      nullable: true,
    },
    is_remote: {
      type: "boolean",
    },
    job_type: {
      $ref: "#/components/schemas/JobTypeEnum",
    },
    degree_requirements: {
      type: "string",
      description: "Required educational qualifications",
    },
    years_of_experience: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
      description: "Required years of experience",
    },
    benefits_and_perks: {
      type: "string",
      description: "List of benefits and perks offered",
    },
    visa_sponsor: {
      type: "boolean",
    },
    created_by: {
      type: "integer",
    },
    company: {
      type: "integer",
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: [
    "benefits_and_perks",
    "city",
    "company",
    "company_name",
    "country",
    "created_at",
    "created_by",
    "degree_requirements",
    "description",
    "id",
    "keywords",
    "salary_max",
    "salary_min",
    "state",
    "title",
    "updated_at",
    "years_of_experience",
  ],
} as const;

export const $JobSkillMatrix = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    job: {
      type: "integer",
    },
    job_title: {
      type: "string",
      readOnly: true,
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    skills_data: {
      description:
        "Required skill levels and weights in format: {skill_id: {'required_level': 0-10, 'weight': 0-1}}",
    },
    last_updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
  },
  required: ["company_name", "id", "job", "job_title", "last_updated"],
} as const;

export const $JobTypeEnum = {
  enum: ["full-time", "intern", "volunteering"],
  type: "string",
  description: `* \`full-time\` - Full Time
* \`intern\` - Intern
* \`volunteering\` - Volunteering`,
} as const;

export const $JobTypesEnum = {
  enum: ["Full Time", "Contract", "Internship", "Co-Founder"],
  type: "string",
  description: `* \`Full Time\` - Full Time
* \`Contract\` - Contract
* \`Internship\` - Internship
* \`Co-Founder\` - Co-Founder`,
} as const;

export const $Login = {
  type: "object",
  properties: {
    email: {
      type: "string",
      format: "email",
    },
    password: {
      type: "string",
    },
  },
  required: ["email", "password"],
} as const;

export const $MatchResult = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    user: {
      type: "integer",
      readOnly: true,
    },
    user_name: {
      type: "string",
      readOnly: true,
    },
    user_email: {
      type: "string",
      readOnly: true,
    },
    job: {
      type: "integer",
      readOnly: true,
      nullable: true,
    },
    job_title: {
      type: "string",
      readOnly: true,
    },
    job_company: {
      type: "string",
      readOnly: true,
    },
    volunteer_opportunity: {
      type: "integer",
      readOnly: true,
      nullable: true,
    },
    volunteer_title: {
      type: "string",
      readOnly: true,
    },
    volunteer_company: {
      type: "string",
      readOnly: true,
    },
    match_type: {
      allOf: [
        {
          $ref: "#/components/schemas/MatchTypeEnum",
        },
      ],
      readOnly: true,
    },
    status: {
      $ref: "#/components/schemas/MatchResultStatusEnum",
    },
    confidence_score: {
      type: "number",
      format: "double",
      readOnly: true,
    },
    skill_gaps: {
      readOnly: true,
      description: "Skill gaps between user and job/opportunity",
    },
    algorithm_version: {
      type: "string",
      readOnly: true,
    },
    match_metadata: {
      readOnly: true,
      description: "Additional algorithm metadata",
    },
    is_saved: {
      type: "boolean",
      description: "User saved this match for later review",
    },
    is_good_fit: {
      type: "boolean",
      description: "User marked this as a good fit",
    },
    is_not_for_me: {
      type: "boolean",
      description: "User marked this as not suitable",
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    expires_at: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
  },
  required: [
    "algorithm_version",
    "confidence_score",
    "created_at",
    "id",
    "job",
    "job_company",
    "job_title",
    "match_metadata",
    "match_type",
    "skill_gaps",
    "updated_at",
    "user",
    "user_email",
    "user_name",
    "volunteer_company",
    "volunteer_opportunity",
    "volunteer_title",
  ],
} as const;

export const $MatchResultStatusEnum = {
  enum: ["pending", "matched", "rejected", "expired"],
  type: "string",
  description: `* \`pending\` - Pending
* \`matched\` - Matched
* \`rejected\` - Rejected
* \`expired\` - Expired`,
} as const;

export const $MatchTypeEnum = {
  enum: ["job", "volunteer"],
  type: "string",
  description: `* \`job\` - Job Match
* \`volunteer\` - Volunteer Match`,
} as const;

export const $MatchingSession = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    session_id: {
      type: "string",
      readOnly: true,
    },
    user: {
      type: "integer",
    },
    user_name: {
      type: "string",
      readOnly: true,
    },
    match_type: {
      $ref: "#/components/schemas/MatchTypeEnum",
    },
    filters_applied: {
      description: "Filters applied during matching",
    },
    results_count: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    completed_at: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
  },
  required: [
    "created_at",
    "id",
    "match_type",
    "session_id",
    "user",
    "user_name",
  ],
} as const;

export const $MatchingSkill = {
  type: "object",
  description: "Serializer for the matching skill reference",
  properties: {
    id: {
      type: "integer",
    },
    name: {
      type: "string",
    },
    category: {
      type: "string",
      nullable: true,
    },
  },
  required: ["category", "id", "name"],
} as const;

export const $Message = {
  type: "object",
  properties: {
    message: {
      type: "string",
    },
  },
  required: ["message"],
} as const;

export const $NonProfitProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    mission_statement: {
      type: "string",
      description: "Mission statement of the nonprofit",
    },
    programs: {
      type: "string",
      description: "Programs or services offered by the nonprofit",
    },
    volunteer_opportunities: {
      type: "string",
      description: "Available volunteer opportunities within the nonprofit",
    },
    company: {
      type: "integer",
    },
  },
  required: ["company", "id"],
} as const;

export const $NullEnum = {
  enum: [null],
} as const;

export const $OpportunityTypeEnum = {
  enum: ["All", "Full Time", "Part Time", "Volunteer", "AI gig"],
  type: "string",
  description: `* \`All\` - All
* \`Full Time\` - Full Time
* \`Part Time\` - Part Time
* \`Volunteer\` - Volunteer
* \`AI gig\` - AI gig`,
} as const;

export const $PaginatedApplicationList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Application",
      },
    },
  },
} as const;

export const $PaginatedApplicationSkillList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ApplicationSkill",
      },
    },
  },
} as const;

export const $PaginatedAwardList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Award",
      },
    },
  },
} as const;

export const $PaginatedCertificationList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Certification",
      },
    },
  },
} as const;

export const $PaginatedChangeLogEntryList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ChangeLogEntry",
      },
    },
  },
} as const;

export const $PaginatedCompanyList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Company",
      },
    },
  },
} as const;

export const $PaginatedEducationList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Education",
      },
    },
  },
} as const;

export const $PaginatedEventListList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/EventList",
      },
    },
  },
} as const;

export const $PaginatedExperienceList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Experience",
      },
    },
  },
} as const;

export const $PaginatedJobProfileList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/JobProfile",
      },
    },
  },
} as const;

export const $PaginatedJobSkillMatrixList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/JobSkillMatrix",
      },
    },
  },
} as const;

export const $PaginatedMatchResultList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MatchResult",
      },
    },
  },
} as const;

export const $PaginatedMatchingSessionList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/MatchingSession",
      },
    },
  },
} as const;

export const $PaginatedNonProfitProfileList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/NonProfitProfile",
      },
    },
  },
} as const;

export const $PaginatedProfileList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Profile",
      },
    },
  },
} as const;

export const $PaginatedProjectList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Project",
      },
    },
  },
} as const;

export const $PaginatedPublicationList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Publication",
      },
    },
  },
} as const;

export const $PaginatedResourceListList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ResourceList",
      },
    },
  },
} as const;

export const $PaginatedSkillCategoryList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SkillCategory",
      },
    },
  },
} as const;

export const $PaginatedSkillList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Skill",
      },
    },
  },
} as const;

export const $PaginatedSmallBusinessProfileList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/SmallBusinessProfile",
      },
    },
  },
} as const;

export const $PaginatedTagList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
    },
  },
} as const;

export const $PaginatedUserList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/User",
      },
    },
  },
} as const;

export const $PaginatedUserSkillMatrixList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/UserSkillMatrix",
      },
    },
  },
} as const;

export const $PaginatedVolunteerOpportunityList = {
  type: "object",
  required: ["count", "results"],
  properties: {
    count: {
      type: "integer",
      example: 123,
    },
    next: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=400&limit=100",
    },
    previous: {
      type: "string",
      nullable: true,
      format: "uri",
      example: "http://api.example.org/accounts/?offset=200&limit=100",
    },
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/VolunteerOpportunity",
      },
    },
  },
} as const;

export const $PatchedApplication = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    experiences: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Experience",
      },
      readOnly: true,
    },
    educations: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Education",
      },
      readOnly: true,
    },
    skills: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ApplicationSkill",
      },
      readOnly: true,
    },
    projects: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Project",
      },
      readOnly: true,
    },
    awards: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Award",
      },
      readOnly: true,
    },
    certifications: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Certification",
      },
      readOnly: true,
    },
    publications: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Publication",
      },
      readOnly: true,
    },
    profiles: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Profile",
      },
      readOnly: true,
    },
    linkedin: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    github: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    portfolio: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    description: {
      type: "string",
    },
    summary: {
      type: "string",
      description: "Professional summary or objective",
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    user: {
      type: "integer",
    },
  },
} as const;

export const $PatchedApplicationSkill = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    score: {
      type: "integer",
      maximum: 2147483647,
      minimum: -2147483648,
    },
    application: {
      type: "integer",
    },
    matching_skill: {
      allOf: [
        {
          $ref: "#/components/schemas/MatchingSkill",
        },
      ],
      readOnly: true,
    },
    matching_skill_id: {
      type: "integer",
      writeOnly: true,
      nullable: true,
    },
  },
} as const;

export const $PatchedAward = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    issuer: {
      type: "string",
      maxLength: 255,
    },
    date_received: {
      type: "string",
      format: "date",
      nullable: true,
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedCertification = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    issuer: {
      type: "string",
      maxLength: 255,
    },
    issue_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    expiry_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    credential_id: {
      type: "string",
      maxLength: 255,
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedCompany = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    smallbiz_profile: {
      allOf: [
        {
          $ref: "#/components/schemas/SmallBusinessProfile",
        },
      ],
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    address: {
      type: "string",
    },
    description: {
      type: "string",
    },
    website: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    logo: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    contact_email: {
      oneOf: [
        {
          type: "string",
          format: "email",
          maxLength: 254,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    phone_number: {
      type: "string",
      maxLength: 20,
    },
    is_small_business: {
      type: "boolean",
      description:
        "Check if this is a small business (listed on volunteer portal)",
    },
    is_nonprofit: {
      type: "boolean",
      description: "Check if this is a nonprofit organization",
    },
    industry: {
      oneOf: [
        {
          $ref: "#/components/schemas/IndustryEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    employee_count: {
      oneOf: [
        {
          $ref: "#/components/schemas/EmployeeCountEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    culture: {
      type: "string",
      description: "Describe the company culture, values, and work environment",
    },
    hiring_goals: {
      type: "string",
      description: "Describe the company's hiring goals and objectives",
    },
    roles_hiring_for: {
      type: "string",
      description: "Types of roles the company is currently hiring for",
    },
    positions_to_hire: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
      nullable: true,
      description: "Number of positions the company plans to hire",
    },
  },
} as const;

export const $PatchedEducation = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    institution: {
      type: "string",
      maxLength: 255,
    },
    degree: {
      type: "string",
      maxLength: 255,
    },
    field_of_study: {
      type: "string",
      maxLength: 255,
    },
    gpa: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,1}(?:\\.\\d{0,2})?$",
      nullable: true,
      description: "Grade Point Average (0.00-4.00)",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedEvent = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 200,
    },
    description: {
      type: "string",
    },
    event_type: {
      $ref: "#/components/schemas/EventTypeEnum",
    },
    start_date: {
      type: "string",
      format: "date-time",
    },
    end_date: {
      type: "string",
      format: "date-time",
    },
    location: {
      type: "string",
      maxLength: 200,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    is_online: {
      type: "boolean",
    },
    online_url: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    max_participants: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
      nullable: true,
    },
    current_participants: {
      type: "integer",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
      readOnly: true,
    },
    tag_ids: {
      type: "array",
      items: {
        type: "integer",
        writeOnly: true,
      },
      writeOnly: true,
    },
    organizer_name: {
      type: "string",
      maxLength: 200,
    },
    organizer_email: {
      type: "string",
      format: "email",
      maxLength: 254,
    },
    organizer_phone: {
      type: "string",
      maxLength: 20,
    },
    registration_required: {
      type: "boolean",
    },
    registration_deadline: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
    cost: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
      nullable: true,
    },
    currency: {
      type: "string",
      maxLength: 3,
    },
    is_full: {
      type: "boolean",
      readOnly: true,
    },
    registration_open: {
      type: "boolean",
      readOnly: true,
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
} as const;

export const $PatchedExperience = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    company: {
      type: "string",
      maxLength: 255,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    city: {
      type: "string",
      maxLength: 255,
    },
    state: {
      type: "string",
      maxLength: 255,
    },
    country: {
      type: "string",
      maxLength: 255,
    },
    is_remote: {
      type: "boolean",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    responsibilities: {
      type: "string",
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedJobProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    keywords: {
      type: "string",
    },
    salary_min: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
    },
    salary_max: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
    },
    city: {
      type: "string",
      maxLength: 255,
    },
    state: {
      type: "string",
      maxLength: 255,
    },
    country: {
      type: "string",
      maxLength: 255,
    },
    latitude: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,3}(?:\\.\\d{0,6})?$",
      nullable: true,
    },
    longitude: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,3}(?:\\.\\d{0,6})?$",
      nullable: true,
    },
    is_remote: {
      type: "boolean",
    },
    job_type: {
      $ref: "#/components/schemas/JobTypeEnum",
    },
    degree_requirements: {
      type: "string",
      description: "Required educational qualifications",
    },
    years_of_experience: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
      description: "Required years of experience",
    },
    benefits_and_perks: {
      type: "string",
      description: "List of benefits and perks offered",
    },
    visa_sponsor: {
      type: "boolean",
    },
    created_by: {
      type: "integer",
    },
    company: {
      type: "integer",
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
} as const;

export const $PatchedJobSkillMatrix = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    job: {
      type: "integer",
    },
    job_title: {
      type: "string",
      readOnly: true,
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    skills_data: {
      description:
        "Required skill levels and weights in format: {skill_id: {'required_level': 0-10, 'weight': 0-1}}",
    },
    last_updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
  },
} as const;

export const $PatchedMatchResult = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    user: {
      type: "integer",
      readOnly: true,
    },
    user_name: {
      type: "string",
      readOnly: true,
    },
    user_email: {
      type: "string",
      readOnly: true,
    },
    job: {
      type: "integer",
      readOnly: true,
      nullable: true,
    },
    job_title: {
      type: "string",
      readOnly: true,
    },
    job_company: {
      type: "string",
      readOnly: true,
    },
    volunteer_opportunity: {
      type: "integer",
      readOnly: true,
      nullable: true,
    },
    volunteer_title: {
      type: "string",
      readOnly: true,
    },
    volunteer_company: {
      type: "string",
      readOnly: true,
    },
    match_type: {
      allOf: [
        {
          $ref: "#/components/schemas/MatchTypeEnum",
        },
      ],
      readOnly: true,
    },
    status: {
      $ref: "#/components/schemas/MatchResultStatusEnum",
    },
    confidence_score: {
      type: "number",
      format: "double",
      readOnly: true,
    },
    skill_gaps: {
      readOnly: true,
      description: "Skill gaps between user and job/opportunity",
    },
    algorithm_version: {
      type: "string",
      readOnly: true,
    },
    match_metadata: {
      readOnly: true,
      description: "Additional algorithm metadata",
    },
    is_saved: {
      type: "boolean",
      description: "User saved this match for later review",
    },
    is_good_fit: {
      type: "boolean",
      description: "User marked this as a good fit",
    },
    is_not_for_me: {
      type: "boolean",
      description: "User marked this as not suitable",
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    expires_at: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
  },
} as const;

export const $PatchedNonProfitProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    mission_statement: {
      type: "string",
      description: "Mission statement of the nonprofit",
    },
    programs: {
      type: "string",
      description: "Programs or services offered by the nonprofit",
    },
    volunteer_opportunities: {
      type: "string",
      description: "Available volunteer opportunities within the nonprofit",
    },
    company: {
      type: "integer",
    },
  },
} as const;

export const $PatchedProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    platform: {
      $ref: "#/components/schemas/PlatformEnum",
    },
    username: {
      type: "string",
      maxLength: 255,
    },
    profile_url: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    rating: {
      type: "integer",
      maximum: 2147483647,
      minimum: -2147483648,
      nullable: true,
    },
    solved_problems: {
      type: "integer",
      maximum: 2147483647,
      minimum: -2147483648,
      nullable: true,
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedProject = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    link: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedPublication = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    authors: {
      type: "string",
      maxLength: 500,
    },
    journal_or_conference: {
      type: "string",
      maxLength: 255,
    },
    publication_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    doi: {
      type: "string",
      maxLength: 255,
    },
    link: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    application: {
      type: "integer",
    },
  },
} as const;

export const $PatchedResource = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 200,
    },
    description: {
      type: "string",
    },
    resource_type: {
      $ref: "#/components/schemas/ResourceTypeEnum",
    },
    url: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    file: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    author: {
      type: "string",
      maxLength: 200,
    },
    publisher: {
      type: "string",
      maxLength: 200,
    },
    published_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    language: {
      type: "string",
      maxLength: 10,
    },
    is_free: {
      type: "boolean",
    },
    cost: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
      nullable: true,
    },
    currency: {
      type: "string",
      maxLength: 3,
    },
    location: {
      type: "string",
      maxLength: 200,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    is_active: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
      readOnly: true,
    },
    tag_ids: {
      type: "array",
      items: {
        type: "integer",
        writeOnly: true,
      },
      writeOnly: true,
    },
    views_count: {
      type: "integer",
      readOnly: true,
    },
    download_count: {
      type: "integer",
      readOnly: true,
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
} as const;

export const $PatchedSmallBusinessProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    company: {
      type: "integer",
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    company_address: {
      type: "string",
      readOnly: true,
    },
    years_operating: {
      oneOf: [
        {
          $ref: "#/components/schemas/YearsOperatingEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    digital_proficiency: {
      nullable: true,
      description: `1 = Very Basic, 5 = Highly Advanced

* \`1\` - 1
* \`2\` - 2
* \`3\` - 3
* \`4\` - 4
* \`5\` - 5`,
      minimum: 0,
      maximum: 32767,
      oneOf: [
        {
          $ref: "#/components/schemas/DigitalProficiencyEnum",
        },
        {
          $ref: "#/components/schemas/NullEnum",
        },
      ],
    },
    seeking_volunteers: {
      type: "boolean",
      description: "Is this business currently seeking volunteers?",
    },
    problems_facing: {
      type: "string",
      description:
        "Describe the main problems or challenges the business is facing",
    },
    volunteer_roles: {
      type: "string",
      description: "Describe volunteer roles or needs",
    },
    opt_in_for_events: {
      type: "boolean",
      description:
        "Opt-in to receive information about volunteer events and opportunities",
    },
  },
} as const;

export const $PatchedSubmission = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    team: {
      type: "integer",
    },
    team_name: {
      type: "string",
      readOnly: true,
    },
    hackathon: {
      type: "integer",
    },
    hackathon_name: {
      type: "string",
      readOnly: true,
    },
    repo_url: {
      description: "Link to the team's code repository.",
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    video_url: {
      description: "Optional demo video link.",
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    status: {
      allOf: [
        {
          $ref: "#/components/schemas/SubmissionStatusEnum",
        },
      ],
      readOnly: true,
    },
    validation_notes: {
      type: "string",
      readOnly: true,
      description: "Why the submission failed validation, if it did.",
    },
    roster_snapshot: {
      readOnly: true,
      description: "Immutable roster captured at lock time.",
    },
    is_locked: {
      type: "boolean",
      readOnly: true,
    },
    locked_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
      nullable: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
} as const;

export const $PatchedUser = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    email: {
      type: "string",
      format: "email",
      maxLength: 255,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    phone_number: {
      type: "string",
      maxLength: 15,
    },
    profile_picture: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    resume: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    address: {
      type: "integer",
      nullable: true,
      description:
        "User's primary address for job matching and location-based features",
    },
    address_details: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      readOnly: true,
    },
    address_data: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      writeOnly: true,
    },
    is_active: {
      type: "boolean",
      description:
        "Designates whether this user should be treated as active. Unselect this instead of deleting accounts.",
    },
    is_staff: {
      type: "boolean",
      description: "Designates whether the user can log into this admin site.",
    },
    is_superuser: {
      type: "boolean",
      title: "Superuser status",
      description:
        "Designates that this user has all permissions without explicitly assigning them.",
    },
    created: {
      type: "string",
      format: "date-time",
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    last_login: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
    role: {
      $ref: "#/components/schemas/RoleEnum",
    },
    business_role: {
      description: `Specific role within the small business (if applicable)

* \`owner\` - Owner/Founder
* \`ceo\` - CEO/President
* \`gm\` - General Manager
* \`marketing\` - Marketing Manager
* \`operations\` - Operations Manager
* \`hr\` - HR Manager
* \`finance\` - Finance Manager
* \`sales\` - Sales Manager
* \`it\` - IT Manager
* \`customer_service\` - Customer Service Manager
* \`consultant\` - Consultant
* \`recruiter\` - Recruiter
* \`other\` - Other`,
      oneOf: [
        {
          $ref: "#/components/schemas/BusinessRoleEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    is_volunteer: {
      type: "boolean",
      description: "Check if this candidate is available as a volunteer",
    },
    is_looking_for_job: {
      type: "boolean",
      description: "Check if this candidate is actively looking for a job",
    },
    company: {
      type: "integer",
      nullable: true,
    },
    applicationids: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ApplicationID",
      },
      readOnly: true,
    },
  },
} as const;

export const $PatchedUserSkillMatrix = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    user: {
      type: "integer",
      readOnly: true,
    },
    user_name: {
      type: "string",
      readOnly: true,
    },
    user_email: {
      type: "string",
      readOnly: true,
    },
    skills_data: {
      description:
        "Skill scores and preferences in format: {skill_id: {'score': 0-10, 'preference': 0-10}}",
    },
    last_updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
  },
} as const;

export const $PatchedVolunteerOpportunity = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    company: {
      type: "integer",
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    company_type: {
      type: "string",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    skills_data: {
      description: "Required skill levels and weights",
    },
    is_active: {
      type: "boolean",
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
} as const;

export const $PlatformEnum = {
  enum: [
    "leetcode",
    "codeforces",
    "codechef",
    "hackerrank",
    "github",
    "linkedin",
    "other",
  ],
  type: "string",
  description: `* \`leetcode\` - LeetCode
* \`codeforces\` - Codeforces
* \`codechef\` - CodeChef
* \`hackerrank\` - HackerRank
* \`github\` - GitHub
* \`linkedin\` - LinkedIn
* \`other\` - Other`,
} as const;

export const $PreferredSalaryEnum = {
  enum: ["10K - 100K", "100K - 200K", "200K - 300K", "More than 300K"],
  type: "string",
  description: `* \`10K - 100K\` - 10K - 100K
* \`100K - 200K\` - 100K - 200K
* \`200K - 300K\` - 200K - 300K
* \`More than 300K\` - More than 300K`,
} as const;

export const $Profile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    platform: {
      $ref: "#/components/schemas/PlatformEnum",
    },
    username: {
      type: "string",
      maxLength: 255,
    },
    profile_url: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    rating: {
      type: "integer",
      maximum: 2147483647,
      minimum: -2147483648,
      nullable: true,
    },
    solved_problems: {
      type: "integer",
      maximum: 2147483647,
      minimum: -2147483648,
      nullable: true,
    },
    application: {
      type: "integer",
    },
  },
  required: ["application", "id", "platform", "username"],
} as const;

export const $Project = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    start_date: {
      type: "string",
      format: "date",
    },
    end_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    link: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    application: {
      type: "integer",
    },
  },
  required: ["application", "description", "id", "name", "start_date"],
} as const;

export const $Publication = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    authors: {
      type: "string",
      maxLength: 500,
    },
    journal_or_conference: {
      type: "string",
      maxLength: 255,
    },
    publication_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    doi: {
      type: "string",
      maxLength: 255,
    },
    link: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    application: {
      type: "integer",
    },
  },
  required: ["application", "id", "title"],
} as const;

export const $Resource = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 200,
    },
    description: {
      type: "string",
    },
    resource_type: {
      $ref: "#/components/schemas/ResourceTypeEnum",
    },
    url: {
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    file: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    author: {
      type: "string",
      maxLength: 200,
    },
    publisher: {
      type: "string",
      maxLength: 200,
    },
    published_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
    language: {
      type: "string",
      maxLength: 10,
    },
    is_free: {
      type: "boolean",
    },
    cost: {
      type: "string",
      format: "decimal",
      pattern: "^-?\\d{0,8}(?:\\.\\d{0,2})?$",
      nullable: true,
    },
    currency: {
      type: "string",
      maxLength: 3,
    },
    location: {
      type: "string",
      maxLength: 200,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    is_active: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
      readOnly: true,
    },
    tag_ids: {
      type: "array",
      items: {
        type: "integer",
        writeOnly: true,
      },
      writeOnly: true,
    },
    views_count: {
      type: "integer",
      readOnly: true,
    },
    download_count: {
      type: "integer",
      readOnly: true,
    },
    created: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: [
    "author",
    "created",
    "description",
    "download_count",
    "id",
    "modified",
    "tags",
    "title",
    "views_count",
  ],
} as const;

export const $ResourceList = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 200,
    },
    resource_type: {
      $ref: "#/components/schemas/ResourceTypeEnum",
    },
    author: {
      type: "string",
      maxLength: 200,
    },
    is_free: {
      type: "boolean",
    },
    location: {
      type: "string",
      maxLength: 200,
    },
    city: {
      type: "string",
      maxLength: 100,
    },
    country: {
      type: "string",
      maxLength: 100,
    },
    is_active: {
      type: "boolean",
    },
    tags: {
      type: "array",
      items: {
        $ref: "#/components/schemas/Tag",
      },
      readOnly: true,
    },
    views_count: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
    },
    download_count: {
      type: "integer",
      maximum: 2147483647,
      minimum: 0,
    },
    published_date: {
      type: "string",
      format: "date",
      nullable: true,
    },
  },
  required: ["author", "id", "tags", "title"],
} as const;

export const $ResourceTypeEnum = {
  enum: [
    "article",
    "video",
    "podcast",
    "ebook",
    "template",
    "tool",
    "course",
    "guide",
    "other",
  ],
  type: "string",
  description: `* \`article\` - Article
* \`video\` - Video
* \`podcast\` - Podcast
* \`ebook\` - E-Book
* \`template\` - Template
* \`tool\` - Tool
* \`course\` - Course
* \`guide\` - Guide
* \`other\` - Other`,
} as const;

export const $RoleEnum = {
  enum: [
    "admin",
    "staff",
    "candidate",
    "recruiter",
    "smallbiz_owner",
    "nonprofit",
  ],
  type: "string",
  description: `* \`admin\` - Admin
* \`staff\` - Staff
* \`candidate\` - Candidate
* \`recruiter\` - Recruiter
* \`smallbiz_owner\` - Small Business Owner
* \`nonprofit\` - Nonprofit Organization`,
} as const;

export const $SearchRequest = {
  type: "object",
  description: "Serializer for search request",
  properties: {
    query: {
      type: "string",
      description:
        "Natural language search query (e.g., 'backend engineer with 5 years experience around DC')",
      maxLength: 500,
    },
    filters: {
      type: "object",
      additionalProperties: {},
      description: "Additional filters (location, experience_level, etc.)",
    },
    limit: {
      type: "integer",
      maximum: 100,
      minimum: 1,
      default: 20,
      description: "Maximum number of results to return",
    },
  },
  required: ["query"],
} as const;

export const $SearchResponse = {
  type: "object",
  description: "Serializer for search response",
  properties: {
    results: {
      type: "array",
      items: {
        $ref: "#/components/schemas/CandidateSearch",
      },
    },
    total_count: {
      type: "integer",
    },
    query: {
      type: "string",
    },
    filters_applied: {
      type: "object",
      additionalProperties: {},
    },
    search_time_ms: {
      type: "number",
      format: "double",
    },
  },
  required: [
    "filters_applied",
    "query",
    "results",
    "search_time_ms",
    "total_count",
  ],
} as const;

export const $SendEmail = {
  type: "object",
  properties: {
    subject: {
      type: "string",
      maxLength: 200,
    },
    body: {
      type: "string",
    },
    from_email: {
      type: "string",
      format: "email",
    },
    to_email: {
      type: "string",
      format: "email",
    },
  },
  required: ["body", "from_email", "subject", "to_email"],
} as const;

export const $Session = {
  type: "object",
  properties: {
    isauthenticated: {
      type: "boolean",
    },
  },
  required: ["isauthenticated"],
} as const;

export const $Signup = {
  type: "object",
  properties: {
    email: {
      type: "string",
      format: "email",
      maxLength: 255,
    },
    password: {
      type: "string",
      writeOnly: true,
      maxLength: 128,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    phone_number: {
      type: "string",
      maxLength: 15,
    },
    address_data: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      writeOnly: true,
    },
    role: {
      $ref: "#/components/schemas/RoleEnum",
    },
  },
  required: ["email", "name", "password"],
} as const;

export const $Skill = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 100,
    },
    category: {
      allOf: [
        {
          $ref: "#/components/schemas/SkillCategory",
        },
      ],
      readOnly: true,
    },
    synonyms: {
      description: "Alternative names for this skill",
    },
    description: {
      type: "string",
    },
    is_active: {
      type: "boolean",
    },
  },
  required: ["category", "id", "name"],
} as const;

export const $SkillCategory = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 100,
    },
    description: {
      type: "string",
    },
    parent: {
      type: "integer",
      nullable: true,
    },
    is_active: {
      type: "boolean",
    },
  },
  required: ["id", "name"],
} as const;

export const $SkillSearch = {
  type: "object",
  description: "Serializer for skills in search results",
  properties: {
    name: {
      type: "string",
    },
    score: {
      type: "integer",
    },
  },
  required: ["name", "score"],
} as const;

export const $SmallBusinessProfile = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    company: {
      type: "integer",
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    company_address: {
      type: "string",
      readOnly: true,
    },
    years_operating: {
      oneOf: [
        {
          $ref: "#/components/schemas/YearsOperatingEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    digital_proficiency: {
      nullable: true,
      description: `1 = Very Basic, 5 = Highly Advanced

* \`1\` - 1
* \`2\` - 2
* \`3\` - 3
* \`4\` - 4
* \`5\` - 5`,
      minimum: 0,
      maximum: 32767,
      oneOf: [
        {
          $ref: "#/components/schemas/DigitalProficiencyEnum",
        },
        {
          $ref: "#/components/schemas/NullEnum",
        },
      ],
    },
    seeking_volunteers: {
      type: "boolean",
      description: "Is this business currently seeking volunteers?",
    },
    problems_facing: {
      type: "string",
      description:
        "Describe the main problems or challenges the business is facing",
    },
    volunteer_roles: {
      type: "string",
      description: "Describe volunteer roles or needs",
    },
    opt_in_for_events: {
      type: "boolean",
      description:
        "Opt-in to receive information about volunteer events and opportunities",
    },
  },
  required: ["company", "company_address", "company_name", "id"],
} as const;

export const $Submission = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    team: {
      type: "integer",
    },
    team_name: {
      type: "string",
      readOnly: true,
    },
    hackathon: {
      type: "integer",
    },
    hackathon_name: {
      type: "string",
      readOnly: true,
    },
    repo_url: {
      description: "Link to the team's code repository.",
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    video_url: {
      description: "Optional demo video link.",
      oneOf: [
        {
          type: "string",
          format: "uri",
          maxLength: 200,
        },
        {
          type: "string",
          maxLength: 0,
        },
      ],
    },
    status: {
      allOf: [
        {
          $ref: "#/components/schemas/SubmissionStatusEnum",
        },
      ],
      readOnly: true,
    },
    validation_notes: {
      type: "string",
      readOnly: true,
      description: "Why the submission failed validation, if it did.",
    },
    roster_snapshot: {
      readOnly: true,
      description: "Immutable roster captured at lock time.",
    },
    is_locked: {
      type: "boolean",
      readOnly: true,
    },
    locked_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
      nullable: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: [
    "hackathon",
    "hackathon_name",
    "id",
    "is_locked",
    "locked_at",
    "roster_snapshot",
    "status",
    "team",
    "team_name",
    "updated_at",
    "validation_notes",
  ],
} as const;

export const $SubmissionStatusEnum = {
  enum: ["draft", "valid", "invalid", "locked"],
  type: "string",
  description: `* \`draft\` - Draft
* \`valid\` - Valid
* \`invalid\` - Invalid
* \`locked\` - Locked`,
} as const;

export const $Tag = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    name: {
      type: "string",
      maxLength: 100,
    },
    color: {
      type: "string",
      description: "Hex color code",
      maxLength: 7,
    },
  },
  required: ["id", "name"],
} as const;

export const $TeamLeaderboard = {
  type: "object",
  properties: {
    rank: {
      type: "integer",
    },
    id: {
      type: "integer",
    },
    name: {
      type: "string",
    },
    slug: {
      type: "string",
    },
    status: {
      type: "string",
    },
    status_display: {
      type: "string",
    },
    score: {
      type: "integer",
    },
  },
  required: ["id", "name", "rank", "score", "slug", "status", "status_display"],
} as const;

export const $User = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    email: {
      type: "string",
      format: "email",
      maxLength: 255,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    phone_number: {
      type: "string",
      maxLength: 15,
    },
    profile_picture: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    resume: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    address: {
      type: "integer",
      nullable: true,
      description:
        "User's primary address for job matching and location-based features",
    },
    address_details: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      readOnly: true,
    },
    address_data: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      writeOnly: true,
    },
    is_active: {
      type: "boolean",
      description:
        "Designates whether this user should be treated as active. Unselect this instead of deleting accounts.",
    },
    is_staff: {
      type: "boolean",
      description: "Designates whether the user can log into this admin site.",
    },
    is_superuser: {
      type: "boolean",
      title: "Superuser status",
      description:
        "Designates that this user has all permissions without explicitly assigning them.",
    },
    created: {
      type: "string",
      format: "date-time",
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    last_login: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
    role: {
      $ref: "#/components/schemas/RoleEnum",
    },
    business_role: {
      description: `Specific role within the small business (if applicable)

* \`owner\` - Owner/Founder
* \`ceo\` - CEO/President
* \`gm\` - General Manager
* \`marketing\` - Marketing Manager
* \`operations\` - Operations Manager
* \`hr\` - HR Manager
* \`finance\` - Finance Manager
* \`sales\` - Sales Manager
* \`it\` - IT Manager
* \`customer_service\` - Customer Service Manager
* \`consultant\` - Consultant
* \`recruiter\` - Recruiter
* \`other\` - Other`,
      oneOf: [
        {
          $ref: "#/components/schemas/BusinessRoleEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    is_volunteer: {
      type: "boolean",
      description: "Check if this candidate is available as a volunteer",
    },
    is_looking_for_job: {
      type: "boolean",
      description: "Check if this candidate is actively looking for a job",
    },
    company: {
      type: "integer",
      nullable: true,
    },
    applicationids: {
      type: "array",
      items: {
        $ref: "#/components/schemas/ApplicationID",
      },
      readOnly: true,
    },
  },
  required: [
    "address_details",
    "applicationids",
    "email",
    "id",
    "modified",
    "name",
  ],
} as const;

export const $UserSkillMatrix = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    user: {
      type: "integer",
      readOnly: true,
    },
    user_name: {
      type: "string",
      readOnly: true,
    },
    user_email: {
      type: "string",
      readOnly: true,
    },
    skills_data: {
      description:
        "Skill scores and preferences in format: {skill_id: {'score': 0-10, 'preference': 0-10}}",
    },
    last_updated: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    is_active: {
      type: "boolean",
    },
  },
  required: ["id", "last_updated", "user", "user_email", "user_name"],
} as const;

export const $VolunteerOpportunity = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    company: {
      type: "integer",
    },
    company_name: {
      type: "string",
      readOnly: true,
    },
    company_type: {
      type: "string",
      readOnly: true,
    },
    title: {
      type: "string",
      maxLength: 255,
    },
    description: {
      type: "string",
    },
    skills_data: {
      description: "Required skill levels and weights",
    },
    is_active: {
      type: "boolean",
    },
    created_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    updated_at: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
  },
  required: [
    "company",
    "company_name",
    "company_type",
    "created_at",
    "description",
    "id",
    "title",
    "updated_at",
  ],
} as const;

export const $WhoAmI = {
  type: "object",
  properties: {
    id: {
      type: "integer",
      readOnly: true,
    },
    email: {
      type: "string",
      format: "email",
      maxLength: 255,
    },
    name: {
      type: "string",
      maxLength: 255,
    },
    phone_number: {
      type: "string",
      maxLength: 15,
    },
    profile_picture: {
      type: "string",
      format: "uri",
      nullable: true,
    },
    address: {
      type: "integer",
      nullable: true,
      description:
        "User's primary address for job matching and location-based features",
    },
    address_details: {
      allOf: [
        {
          $ref: "#/components/schemas/Address",
        },
      ],
      readOnly: true,
    },
    is_active: {
      type: "boolean",
      description:
        "Designates whether this user should be treated as active. Unselect this instead of deleting accounts.",
    },
    is_staff: {
      type: "boolean",
      description: "Designates whether the user can log into this admin site.",
    },
    is_superuser: {
      type: "boolean",
      title: "Superuser status",
      description:
        "Designates that this user has all permissions without explicitly assigning them.",
    },
    role: {
      $ref: "#/components/schemas/RoleEnum",
    },
    business_role: {
      description: `Specific role within the small business (if applicable)

* \`owner\` - Owner/Founder
* \`ceo\` - CEO/President
* \`gm\` - General Manager
* \`marketing\` - Marketing Manager
* \`operations\` - Operations Manager
* \`hr\` - HR Manager
* \`finance\` - Finance Manager
* \`sales\` - Sales Manager
* \`it\` - IT Manager
* \`customer_service\` - Customer Service Manager
* \`consultant\` - Consultant
* \`recruiter\` - Recruiter
* \`other\` - Other`,
      oneOf: [
        {
          $ref: "#/components/schemas/BusinessRoleEnum",
        },
        {
          $ref: "#/components/schemas/BlankEnum",
        },
      ],
    },
    is_volunteer: {
      type: "boolean",
      description: "Check if this candidate is available as a volunteer",
    },
    is_looking_for_job: {
      type: "boolean",
      description: "Check if this candidate is actively looking for a job",
    },
    company: {
      type: "integer",
      nullable: true,
    },
    created: {
      type: "string",
      format: "date-time",
    },
    modified: {
      type: "string",
      format: "date-time",
      readOnly: true,
    },
    last_login: {
      type: "string",
      format: "date-time",
      nullable: true,
    },
  },
  required: ["address_details", "email", "id", "modified", "name"],
} as const;

export const $YearsOperatingEnum = {
  enum: ["lt1", "1_3", "4_7", "8_15", "15_plus"],
  type: "string",
  description: `* \`lt1\` - Less than 1 year (Startup)
* \`1_3\` - 1-3 years
* \`4_7\` - 4-7 years
* \`8_15\` - 8-15 years
* \`15_plus\` - More than 15 years`,
} as const;
